import { formatZip, sortDates, formatDate } from './modules/utils.js';
import { findCenters, times4Center, loginHome } from './modules/api.js'; 
import { initTooltips } from './modules/tooltips.js';
import { ischeduleData } from './modules/data.js';
import { createCenterHTML, getBrandName } from './modules/centers.js';

jQuery(document).ready(function ($) {

	// Exit early if data couldn't be loaded
	if (!ischeduleData) {
		return;
	}

	console.log("ischeduleData", ischeduleData);

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// LFG !!!!!!!

	userLookup();
	

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// userLookup: by clientToken parameter

    function userLookup() {
		console.log("userLookup()");

		loginHome(ischeduleData.clientToken, ischeduleData.isDev)
			.done(function(response) {
				console.log(response);
				
				if (response.validationErrors) {
					console.error("userLookup validationErrors");
					$(".isched_confirmation__apt_details").removeClass("isched_confirmation__apt_details--loading");
					$(".isched_confirmation__apt_details").addClass("isched_confirmation__apt_details--error");
					return;
				}
		
				response = response.data;

				//response.appointmentInfo
				//response.patientInfo
				
				populateAppointmentData(response);
				populateNextSteps(response);

				// Only show type item if virtual, hide it for in-center appointments
				if (response.appointmentInfo.isVirtual === 1) {
					$(".isched_apt_details__item--virtual").show();
					$(".isched_apt_details__item--location").hide();
					$(".isched_apt_details__item__value--get-directions").hide();
				} else {
					$(".isched_apt_details__item--virtual").hide();
					$(".isched_apt_details__item--location").show();
					$(".isched_apt_details__item__value--get-directions").show();
				}

				$(".isched_confirmation__apt_details").removeClass("isched_confirmation__apt_details--loading");
			
				
			})
			.fail(function(err) {
				console.error('Failed to fetch login home:', err);
			});
  	}


	function populateAppointmentData(response) {
		console.log("populateAppointmentData()");

		const selectedDate = new Date(response.appointmentInfo.apptDate);
		const selectedDateStr = selectedDate.toLocaleDateString("en-US"); // "M/D/YYYY"
		const selectedDateFormatted = selectedDate.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });

		$(".isched_populate_selected_date").html(selectedDateFormatted);
		$(".isched_populate_selected_time").html(response.appointmentInfo.apptTime);
		
		// populate selected center HTML
		// Map centerInfo to the structure expected by createCenterHTML
		if (response.centerInfo) {
			const center = {
				centerCode: response.centerInfo.centerCode,
				address1: response.centerInfo.address1,
				city: response.centerInfo.city,
				state: response.centerInfo.state,
				zipPostal: response.centerInfo.zip, // Map zip to zipPostal
				brand: response.centerInfo.brand,
				ratings: response.centerInfo.ratings,
				userRatingsTotal: response.centerInfo.userRatingsTotal
				// Note: lat, lon, distance may not be available in centerInfo
			};
			
			// Compare center brand with site brand to determine if affiliate
			const siteBrand = ischeduleData.brand || '';
			const centerBrand = response.centerInfo.brand || '';
			const isAffiliate = siteBrand !== '' && centerBrand !== '' && siteBrand !== centerBrand;
			
			$(".isched_populate_selected_center").html(createCenterHTML(center, ischeduleData.pluginUrl, isAffiliate, true, false, true));
			
		} else {
			// Fallback if centerInfo is not available
			$(".isched_populate_selected_center").html(response.appointmentInfo.apptCenterCode || '');
			// Remove affiliate message if it exists
			$(".isched_apt_details__affiliate_message").remove();
		}

		// Build calendar dropdown
		const centerName = response.centerInfo?.centerCode || 'Vision Center';
		const address = response.centerInfo ? 
			`${response.centerInfo.address1 || ''}, ${response.centerInfo.city || ''}, ${response.centerInfo.state || ''} ${response.centerInfo.zip || ''}`.trim() : 
			'';
		
		// Process ICS URL if available
		const icsUrl = processIcsUrl(response.appointmentInfo?.apptICSURL, ischeduleData.isDev);
		
		// Fetch and parse ICS file to generate calendar URLs
		if (icsUrl) {
			$.ajax({
				url: icsUrl,
				method: 'GET',
				dataType: 'text'
			})
			.done(function(icsContent) {
				const eventData = parseICS(icsContent);
				let calendarUrls = createCalendarUrlsFromICS(eventData);
				
				if (calendarUrls) {
					calendarUrls.ics = icsUrl; // Add the ICS download URL
					buildCalendarDropdown(calendarUrls, response);
				} else {
					console.warn('ICS parsing failed, using fallback calendar URLs');
					// Fallback to manual generation if ICS parsing fails
					calendarUrls = createCalendarUrls(
						selectedDateStr,
						response.appointmentInfo.apptTime,
						centerName,
						address,
						icsUrl
					);
					buildCalendarDropdown(calendarUrls, response);
				}
			})
			.fail(function() {
				console.warn('Failed to fetch ICS file, using fallback calendar URLs');
				// Fallback to manual generation if ICS fetch fails
				const calendarUrls = createCalendarUrls(
					selectedDateStr,
					response.appointmentInfo.apptTime,
					centerName,
					address,
					icsUrl
				);
				buildCalendarDropdown(calendarUrls, response);
			});
		} else {
			// No ICS URL available, use manual generation
			const calendarUrls = createCalendarUrls(
				selectedDateStr,
				response.appointmentInfo.apptTime,
				centerName,
				address,
				null
			);
			buildCalendarDropdown(calendarUrls, response);
		}

		
	}

	function populateNextSteps(response) {
		console.log("populateNextSteps()");

		const isLasikCash =	response.appointmentInfo.isLasikCash;
		const lasikCashAmt = response.appointmentInfo.lasikCashAmt;
		const registrationComplete = response.appointmentInfo.registrationComplete;
		const registrationURL = response.appointmentInfo.registrationURL;
		const financingURL = response.patientInfo.financingURL;

		let hasNextSteps = false;

		// registration 
		if (registrationURL && registrationURL !== "" && registrationComplete !== "Y") {
			$(".isched_confirmation__next_steps__item--registration a").attr('href', registrationURL);
			$(".isched_confirmation__next_steps__item--registration").show();
			hasNextSteps = true;
		} else {
			$(".isched_confirmation__next_steps__item--registration").remove();
		}

		// financing
		if (financingURL && financingURL !== "") {
			$(".isched_confirmation__next_steps__item--financing a").attr('href', financingURL);
			$(".isched_confirmation__next_steps__item--financing").show();
			hasNextSteps = true;
		} else {
			$(".isched_confirmation__next_steps__item--financing").remove();
		}
	
		// attend / lasik cash
		if (isLasikCash === "Y" && lasikCashAmt > 0) {
			$(".isched_populate_lasik_cash_amount").text(lasikCashAmt);
			$(".isched_confirmation__next_steps__item--attend").show();
			hasNextSteps = true;
		} else {
			$(".isched_confirmation__next_steps__item--attend").remove();
		}

		if (hasNextSteps) {
			$(".isched_confirmation__next_steps").show();
		}
	
	}

	/**
	 * Processes ICS URL from API response
	 * @param {string} icsPath - The ICS path from API (e.g., "/iScheduleAPI/apptICS.lp?pId=10351811&aId=20884228")
	 * @param {boolean} isDev - Whether we're in dev/staging mode
	 * @returns {string|null} - Full ICS URL or null if path is invalid
	 */
	function processIcsUrl(icsPath, isDev) {
		if (!icsPath) return null;
		
		// Trim whitespace
		const trimmedPath = icsPath.trim();
		
		// If it's already a full URL, return as-is
		if (trimmedPath.startsWith('http://') || trimmedPath.startsWith('https://')) {
			return trimmedPath;
		}
		
		// Replace /iScheduleAPI/ with /iScheduleAPI-dev/ if in dev mode
		let processedPath = trimmedPath;
		if (isDev && processedPath.includes('/iScheduleAPI/')) {
			processedPath = processedPath.replace('/iScheduleAPI/', '/iScheduleAPI-dev/');
		}
		
		// Ensure path starts with /
		if (!processedPath.startsWith('/')) {
			processedPath = '/' + processedPath;
		}
		
		// Build full URL
		return `https://api.lca.com${processedPath}`;
	}

	/**
	 * Parses ICS file content and extracts event data
	 * @param {string} icsContent - The ICS file content as a string
	 * @returns {Object|null} - Parsed event data or null if parsing fails
	 */
	function parseICS(icsContent) {
		if (!icsContent) return null;
		
		const lines = icsContent.split(/\r?\n/);
		const event = {};
		let inEvent = false;
		let currentKey = '';
		
		for (let i = 0; i < lines.length; i++) {
			let line = lines[i];
			
			// Handle line continuation (lines starting with space)
			if (line.startsWith(' ') && currentKey) {
				event[currentKey] += line.substring(1);
				continue;
			}
			
			// Check for VEVENT start
			if (line === 'BEGIN:VEVENT') {
				inEvent = true;
				continue;
			}
			
			// Check for VEVENT end
			if (line === 'END:VEVENT') {
				break;
			}
			
			if (!inEvent) continue;
			
			// Parse key-value pairs
			const colonIndex = line.indexOf(':');
			if (colonIndex === -1) continue;
			
			const key = line.substring(0, colonIndex).split(';')[0]; // Remove parameters
			const value = line.substring(colonIndex + 1);
			
			switch (key) {
				case 'DTSTART':
					event.start = value;
					break;
				case 'DTEND':
					event.end = value;
					break;
				case 'SUMMARY':
					event.summary = value;
					currentKey = 'summary';
					break;
				case 'DESCRIPTION':
					event.description = value;
					currentKey = 'description';
					break;
				case 'LOCATION':
					event.location = value.replace(/\\,/g, ',').replace(/\\;/g, ';'); // Unescape commas and semicolons
					currentKey = 'location';
					break;
				case 'URL':
					event.url = value;
					break;
			}
		}
		
		return Object.keys(event).length > 0 ? event : null;
	}

	/**
	 * Converts ICS date format (YYYYMMDDTHHMMSSZ) to Date object
	 * @param {string} icsDate - ICS formatted date string
	 * @returns {Date} - JavaScript Date object
	 */
	function parseICSDate(icsDate) {
		// Format: 20260112T143000Z or 20260112T143000
		// Remove Z if present and parse
		const dateStr = icsDate.replace(/Z$/, '');
		const year = parseInt(dateStr.substring(0, 4), 10);
		const month = parseInt(dateStr.substring(4, 6), 10) - 1; // JS months are 0-indexed
		const day = parseInt(dateStr.substring(6, 8), 10);
		const hour = dateStr.length > 9 ? parseInt(dateStr.substring(9, 11), 10) : 0;
		const minute = dateStr.length > 11 ? parseInt(dateStr.substring(11, 13), 10) : 0;
		const second = dateStr.length > 13 ? parseInt(dateStr.substring(13, 15), 10) : 0;
		
		return new Date(Date.UTC(year, month, day, hour, minute, second));
	}

	/**
	 * Creates calendar URLs from ICS event data
	 * @param {Object} eventData - Parsed ICS event data
	 * @returns {Object} - Calendar URLs object
	 */
	function createCalendarUrlsFromICS(eventData) {
		if (!eventData || !eventData.start || !eventData.end) {
			return null;
		}
		
		const startDate = parseICSDate(eventData.start);
		const endDate = parseICSDate(eventData.end);
		
		// Format date for Google Calendar (YYYYMMDDTHHMMSSZ)
		// We intentionally emit UTC ("Z") because ICS DTSTART/DTEND may be in UTC
		// and omitting the timezone will make Google treat it as a floating local time.
		const formatGoogleDate = (date) => {
			const y = date.getUTCFullYear();
			const m = String(date.getUTCMonth() + 1).padStart(2, '0');
			const d = String(date.getUTCDate()).padStart(2, '0');
			const h = String(date.getUTCHours()).padStart(2, '0');
			const min = String(date.getUTCMinutes()).padStart(2, '0');
			const s = String(date.getUTCSeconds()).padStart(2, '0');
			return `${y}${m}${d}T${h}${min}${s}Z`;
		};
		
		const title = encodeURIComponent(eventData.summary || 'Appointment');
		const details = encodeURIComponent(eventData.description || '');
		const location = encodeURIComponent(eventData.location || '');
		const startStr = formatGoogleDate(startDate);
		const endStr = formatGoogleDate(endDate);
		
		// Build Apple Calendar data URI from ICS content (or generate minimal one)
		const appleICS = `BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:${eventData.start}%0ADTEND:${eventData.end}%0ASUMMARY:${encodeURIComponent(eventData.summary || 'Appointment')}%0ADESCRIPTION:${encodeURIComponent(eventData.description || '')}%0ALOCATION:${encodeURIComponent(eventData.location || '')}%0AEND:VEVENT%0AEND:VCALENDAR`;
		
		return {
			google: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startStr}/${endStr}&details=${details}&location=${location}`,
			outlook: `https://outlook.live.com/calendar/0/deeplink/compose?subject=${title}&startdt=${startDate.toISOString()}&enddt=${endDate.toISOString()}&location=${location}&body=${details}`,
			apple: `data:text/calendar;charset=utf8,${appleICS}`,
			ics: null // Will be set separately
		};
	}

	/**
	 * Creates calendar URLs for different providers (fallback method)
	 */
	function createCalendarUrls(apptDate, apptTime, centerName, address, icsUrl) {
		// Parse the date and time
		// apptDate format: "M/D/YYYY" (e.g., "12/26/2025")
		// apptTime format: "H:MM am/pm" (e.g., "8:15 am")
		const [month, day, year] = apptDate.split('/');
		const timeMatch = apptTime.match(/(\d+):(\d+)\s*(am|pm)/i);
		
		if (!timeMatch) return null;
		
		let hours = parseInt(timeMatch[1]);
		const minutes = parseInt(timeMatch[2]);
		const ampm = timeMatch[3].toLowerCase();
		
		// Convert to 24-hour format
		if (ampm === 'pm' && hours !== 12) hours += 12;
		if (ampm === 'am' && hours === 12) hours = 0;
		
		// Create date objects
		const startDate = new Date(year, month - 1, day, hours, minutes);
		const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // 1 hour later
		
		// Format date for Google Calendar (YYYYMMDDTHHMMSS)
		const formatGoogleDate = (date) => {
			const y = date.getFullYear();
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const d = String(date.getDate()).padStart(2, '0');
			const h = String(date.getHours()).padStart(2, '0');
			const min = String(date.getMinutes()).padStart(2, '0');
			const s = String(date.getSeconds()).padStart(2, '0');
			return `${y}${m}${d}T${h}${min}${s}`;
		};
		
		const title = encodeURIComponent(`${centerName} Appointment`);
		const details = encodeURIComponent(`Appointment at ${centerName}\n${address || ''}`);
		const location = encodeURIComponent(address || '');
		const startStr = formatGoogleDate(startDate);
		const endStr = formatGoogleDate(endDate);
		
		return {
			google: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startStr}/${endStr}&details=${details}&location=${location}`,
			outlook: `https://outlook.live.com/calendar/0/deeplink/compose?subject=${title}&startdt=${startDate.toISOString()}&enddt=${endDate.toISOString()}&location=${location}&body=${details}`,
			apple: `data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:${startStr}%0ADTEND:${endStr}%0ASUMMARY:${title}%0ADESCRIPTION:${details}%0ALOCATION:${location}%0AEND:VEVENT%0AEND:VCALENDAR`,
			ics: icsUrl || null
		};
	}

	/**
	 * Builds and inserts the calendar dropdown HTML
	 * @param {Object} calendarUrls - Object containing calendar URLs
	 * @param {Object} response - The API response object
	 */
	function buildCalendarDropdown(calendarUrls, response) {
		// Get the existing button text from the template (includes icon)
		const $calendarButton = $(".populate_add_to_calendar");
		const existingButtonText = $calendarButton.html() || 'Add To Calendar';
		
		let calendarDropdownHTML = '';
		
		if (calendarUrls) {
			calendarDropdownHTML = `
				<div class="isched_calendar_dropdown">
					<button class="isched_calendar_dropdown__trigger isched-button isched-button--outlined" type="button">${existingButtonText}</button>
					<div class="isched_calendar_dropdown__menu">
						<a href="${calendarUrls.google}" target="_blank" class="isched_calendar_dropdown__item">Google Calendar</a>
						<a href="${calendarUrls.outlook}" target="_blank" class="isched_calendar_dropdown__item">Outlook</a>
						<a href="${calendarUrls.apple}" download="appointment.ics" class="isched_calendar_dropdown__item">Apple Calendar</a>
						${calendarUrls.ics ? `<a href="${calendarUrls.ics}" target="_blank" download="appointment.ics" class="isched_calendar_dropdown__item">Download .ics file</a>` : ''}
					</div>
				</div>
			`;
		} else {
			calendarDropdownHTML = `<span>${existingButtonText}</span>`;
		}
		
		// Populate calendar dropdown
		$calendarButton.html(calendarDropdownHTML);
		
		// Set directions link href directly on the element
		const $directionsLink = $(".isched_apt_details__item__value--get-directions");
		if (response.centerInfo?.mapURL) {
			$directionsLink.attr('href', response.centerInfo.mapURL);
		} else {
			$directionsLink.remove();
		}
		
		// Initialize dropdown toggle (only if not already initialized)
		if (!$('.isched_calendar_dropdown__trigger').data('initialized')) {
			$('.isched_calendar_dropdown__trigger').data('initialized', true);
			
			$('.isched_calendar_dropdown__trigger').on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				const $dropdown = $(this).closest('.isched_calendar_dropdown');
				const $menu = $dropdown.find('.isched_calendar_dropdown__menu');
				
				// Close other dropdowns
				$('.isched_calendar_dropdown').not($dropdown).removeClass('is-open');
				$('.isched_calendar_dropdown__menu').not($menu).removeClass('is-open');
				
				// Toggle this dropdown
				$dropdown.toggleClass('is-open');
				$menu.toggleClass('is-open');
			});
			
			// Close dropdown when clicking outside
			$(document).on('click', function(e) {
				if (!$(e.target).closest('.isched_calendar_dropdown').length) {
					$('.isched_calendar_dropdown').removeClass('is-open');
					$('.isched_calendar_dropdown__menu').removeClass('is-open');
				}
			});
		}
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// userLookup:  if clientToken parameter is present

	////// Tippy
	initTooltips($);

	  
});




